import { BrCard } from '@govbr-ds/react-components';
import styles from './resumoCard.module.scss';
import InformacaoBasica from 'components/informacaoBasica/informacaoBasica';
import BasicAccordion from 'components/basicAccordion/basicAccordion';
import { useId } from 'react';

interface ResumoCardData {
  label: string;
  value: string;
  large?: boolean;
  showInSummary?: boolean;
  format?: Function;
}

interface ResumoCardProps {
  readonly title: string;
  readonly data: ResumoCardData[];
  readonly showExpandAction?: boolean;
}

function ResumoCard({ title, data, showExpandAction = true }: ResumoCardProps) {
  const componentId = useId();

  const getItemsDetail = () => {
    return data.map((item) => (
      <InformacaoBasica
        key={componentId + item.label}
        titulo={item.label}
        conteudo={item.format ? item.format(item.value) : item.value}
        large={item.large}
      />
    ));
  };
  const getItemsSummary = () => {
    return data
      .filter((e) => e.showInSummary)
      .map((item) => (
        <InformacaoBasica
          key={componentId + item.label}
          titulo={item.label}
          conteudo={item.format ? item.format(item.value) : item.value}
          large={item.large}
        />
      ));
  };

  return (
    <BrCard className={styles.card}>
      <span className={styles.cardTitle}>{title}</span>
      <div className={styles.cardContent}>
        <BasicAccordion
          key={componentId}
          showDetailText='Exibir detalhes'
          showSummaryText='Recolher detalhes'
          summaryData={getItemsSummary()}
          detailData={getItemsDetail()}
          showExpandAction={showExpandAction}
        />
      </div>
    </BrCard>
  );
}

export default ResumoCard;
